module.exports = __webpack_public_path__ + "img/y- (21).7f41d06f.png";